module.exports = __webpack_public_path__ + "img/Junction-4-4.d9e50b3e.png";